import styled from 'styled-components';

export const ButtonGroup = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'stretch',
  marginTop: theme.spacing[24],
  gap: theme.spacing[8],

  '> button, > a': {
    flex: 1,
    width: 'auto',
    height: 'auto',
  },

  [`${theme.mediaBreakpointUp.lg}`]: {
    flexDirection: 'row',
  },
}));
